import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { ModalOptionsTable } from '@Sage/ssm-web5';
import { getLiteral } from 'utils/getLiteral';

/**
 * Modal to view and toggle featured (relevant) extra fields.
 * All state and handlers come from useFeaturedFields; this component is presentational.
 * Shared by CompanyDetailWidget and OpportunityDetailWidget.
 */
const MoreFieldsModal = memo(
    ({
        entityName,
        featuredFields,
        featuredIds,
        isLoading,
        isOpen,
        onCancel,
        onChangeFeatured,
        onClickInput,
        onConfirm,
        sections,
    }) => (
        <ModalOptionsTable
            advice={getLiteral('label_help_featured_fields_modal')}
            cancelText={getLiteral('action_cancel')}
            confirmText={getLiteral('label_accept')}
            entity={entityName}
            featuredFields={featuredFields}
            featuredIds={featuredIds}
            isOpen={isOpen}
            isLoading={isLoading}
            onChangeFeatured={onChangeFeatured}
            onCancel={onCancel}
            onConfirm={onConfirm}
            onClickInput={onClickInput}
            placeholderSearch={getLiteral('label_search_field')}
            sections={sections}
            title={getLiteral('label_preview_customfields')}
        />
    ),
);

MoreFieldsModal.displayName = 'MoreFieldsModal';

MoreFieldsModal.propTypes = {
    entityName: PropTypes.string,
    featuredFields: PropTypes.array,
    featuredIds: PropTypes.object,
    isLoading: PropTypes.bool,
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func,
    onChangeFeatured: PropTypes.func,
    onClickInput: PropTypes.func,
    onConfirm: PropTypes.func,
    sections: PropTypes.array,
};

export default MoreFieldsModal;
